// extracted by mini-css-extract-plugin
module.exports = {"productCarousel":"Di","itemsContainer":"Ei"};